<template>
  <div class="not-found">
    <h1>404</h1>
    <p>The page you are looking for does not exist.</p>
    <router-link to="/">Go back to Home</router-link>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
.not-found {
  text-align: center;
  padding: 80px 20px;
}
.not-found h1 {
  font-size: 80px;
  color: #3a5f49; /* 使用你的主色 */
}
.not-found p {
  margin: 20px 0;
  font-size: 18px;
  color: #666;
}
.not-found a {
  color: #3a5f49;
  text-decoration: underline;
}
</style>
